// test2848
(2848 && 0);
